/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { SecurityHelper } from 'sarsaparilla';
import axios from 'axios';
import { writeSession } from 'shared-ui/auth';
import * as types from '../constants';

export const updateFailed = (err = 'default') => ({
    type: types.ACCOUNT_UPDATE_FAILED,
    payload: { err },
});

export const emailSent = () => ({
    type: types.UPDATE_EMAIL_SENT,
});

export const profileUpdated = () => ({
    type: types.ACCOUNT_UPDATED,
});

export const updateAccount = (acct) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/account`;
            const response = await axios.put(url, acct, {
                headers: { Authorization: SecurityHelper.getAuthHeader() },
            });
            const profile = response.data;
            if ('success' in response.data) {
                dispatch(emailSent());
            } else {
                writeSession(dispatch, profile);
                dispatch(profileUpdated());
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.error || error?.message || 'Unknown error';
            dispatch(updateFailed(errorMessage));
            throw error;
        }
    };
};

export const updatePasses = (acct) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/account/passes`;
            const response = await axios.put(url, acct, {
                headers: { Authorization: SecurityHelper.getAuthHeader() },
            });
            const profile = response.data;
            if ('success' in response.data) {
                dispatch(emailSent());
            } else {
                writeSession(dispatch, profile);
                dispatch(profileUpdated());
            }
        } catch (error) {
            const errorMessage =
                error.response?.data?.error || error?.message || 'Unknown error';
            dispatch(updateFailed(errorMessage));
            throw error;
        }
    };
};

export const updateAccountCommunication = (preferences) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/account/communication`;
            const response = await axios.put(url, preferences, {
                headers: { Authorization: SecurityHelper.getAuthHeader() },
            });
            const profile = response.data;
            writeSession(dispatch, profile);
            dispatch(profileUpdated());
        } catch (err) {
            dispatch(updateFailed(err.response.data.error));
        }
    };
};

export const validateToken = (token) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/account/${token}`;
            const response = await axios.post(
                url,
                {},
                { headers: { Authorization: SecurityHelper.getAuthHeader() } }
            );
            const profile = response.data;
            writeSession(dispatch, profile);
            dispatch(profileUpdated());
        } catch (error) {
            dispatch(updateFailed());
        }
    };
};

export const validateAuthToken = (token) => {
    return async (dispatch) => {
        try {
            const url = `${process.env.API}/accounts/validate`;
            const body = { token };
            const response = await axios.post(url, body);
            const profile = response.data;
            writeSession(dispatch, profile);
            dispatch(profileUpdated());
        } catch (error) {
            dispatch(updateFailed());
        }
    };
};

export const resetProfileMessages = () => {
    return (dispatch) => {
        dispatch({
            type: types.RESET_PROFILE_MESSAGE_FLAGS,
        });
    };
};

export const getAccountRatings = () => {
    return async (dispatch) => {
        try {
            const accountId = SecurityHelper.getAccount().account_id;
            if (!accountId) {
                return;
            }
            const url = `${process.env.API}/ratingreview/ratings/account/${accountId}`;

            const response = await axios.get(url, {
                headers: { Authorization: SecurityHelper.getAuthHeader() },
            });
            const reviews = response.data.ratings;
            const reviewsById = {};
            reviews.map((review) => (reviewsById[review.reservation_id] = review));
            dispatch({
                type: types.FETCH_ACCOUNT_RATINGS_SUCCESS,
                data: reviewsById,
            });
        } catch (error) {
            dispatch({
                type: types.FETCH_ACCOUNT_RATINGS_FAILED,
            });
        }
    };
};

export const validateGuestToken = (profile) => {
    return (dispatch) => {
        try {
            writeSession(dispatch, profile);
            dispatch(profileUpdated());
        } catch (e) {
            dispatch(updateFailed());
        }
    };
};
